import { render, staticRenderFns } from "./GeographicalDetailsModal.vue?vue&type=template&id=08253cbc&scoped=true&"
import script from "./GeographicalDetailsModal.vue?vue&type=script&lang=js&"
export * from "./GeographicalDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./GeographicalDetailsModal.vue?vue&type=style&index=0&id=08253cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08253cbc",
  null
  
)

export default component.exports